import React from "react";
import { Select } from "antd";
import TreeSelect from "@/components/TreeSelect";
import { ModelSelectHelper } from "../../../../../services/Sierra/library";

class SPICERender extends React.Component {

  onChangeEnableVoltage = (enableVoltage) => {
    this.props.setData({ enableVoltage });
  }

  onChangeSubckt = (name) => {
    this.props.setData({ modelName: name });
  }

  onChangeBuffer = (value) => {
    this.props.setData({
      modelType: value,
      modelName: '',
      enableVoltage: "",
    });
  }

  render() {
    const {
      fileName,
      libraryId,
      modelType,
      modelName,
      spiceList,
      subcktNames,
      bufferTypes,
      enableVoltage
    } = this.props;
    return <>
      <div className="div-flex-box">
        <label>Model File</label>
        <TreeSelect
          className="input-component"
          size='small'
          showSearch
          value={fileName || undefined}
          onSelectItem={this.props.onFolderFileChange}
          fileList={spiceList}
          selected={libraryId}
        />
      </div>
      <div className="div-flex-box div-flex-box-child-box">
        <div className="div-flex-box-child">
          <label>Buffer Type</label>
          <Select
            className="input-component"
            size="small"
            value={modelType || ""}
            options={bufferTypes.map((type) => ({ value: type, label: type, title: type }))}
            onChange={this.onChangeBuffer}
          />
        </div>
        {ModelSelectHelper.existEnableVoltage(modelType) ?
          <div className="div-flex-box-child">
            <label>Enable Voltage</label>
            <Select
              value={enableVoltage}
              onChange={this.onChangeEnableVoltage}
              size='small'
              popupMatchSelectWidth={false}
              className="input-component"
              suffixIcon={null}
              allowClear={true}
              getPopupContainer={() => document.getElementById('root')}
              options={[{ value: "1", label: "Active-High" }, { value: "0", label: "Active-Low" }]}
            />
          </div> : null}
        <div className="div-flex-box-child">
          <label>Subckt Name</label>
          <Select
            className="input-component"
            size="small"
            value={modelName || ""}
            options={subcktNames.map(({ name }) => ({ value: name, label: name, title: name }))}
            onChange={this.onChangeSubckt}
          />
        </div>
      </div>
    </>
  }
}

export default SPICERender;